import {
  CalloutLogWorkScreen,
  type CalloutLogWorkScreenProps,
} from '@/screens/CalloutLogWorkScreen'

export type JobLogWorkScreenProps = CalloutLogWorkScreenProps

export function JobLogWorkScreen(props: JobLogWorkScreenProps) {
  return <CalloutLogWorkScreen {...props} resourceLabel="Job" />
}
